export default __webpack_public_path__ + "static/media/puregases-temp.b8bfd5cd.JPG";